/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{cursor:pointer;font-size:12px}[_nghost-%COMP%]   .disabled[_ngcontent-%COMP%]{cursor:not-allowed}"];
export { styles as styles };
